/// <reference path="../../../../typings/index.d.ts" />

module Meevo.Plugins.ProductBundles {
    angular.module('meevo.plugins.productBundles', []);
}